<template>
  <footer
    class="flex flex-col items-center gap-[54px] pb-10 pt-6 px-4 homepage-footer"
  >
    <div class="flex flex-col items-center gap-6">
      <p class="text-base font-semibold text-black">
        Trusted By 50,000+ Customers Across The World
      </p>
      <div class="flex flex-wrap items-center justify-center gap-6">
        <img
          v-for="company in trustedCompanies"
          :key="company.name"
          :src="company.logo"
          :alt="company.name"
          class="h-6 w-auto object-contain"
        />
      </div>
    </div>
    <div class="flex items-center justify-center gap-2 text-base text-gray-600">
      <span>Copyright &copy; 2026 | SuperAGI.</span>
      <span class="text-gray-400">|</span>
      <span>SuperAGI is a product of Contlo INC.</span>
      <span class="text-gray-400">|</span>
      <router-link
        to="/terms"
        class="text-gray-600 hover:text-gray-900 underline"
      >
        Terms of Usage
      </router-link>
      <span class="text-gray-400">|</span>
      <router-link
        to="/privacy-policy"
        class="text-gray-600 hover:text-gray-900 underline"
      >
        Privacy Policy
      </router-link>
      <span class="text-gray-400">|</span>
      <span>Call us at +1 (302) 599-6365</span>
    </div>
  </footer>
</template>

<script setup>
import { trustedCompanies } from "@/src/constants/homepageConstants.js";
</script>

<style scoped>
.homepage-footer {
  border-top: 1px solid var(--white-opacity-8);
  background: var(--white-opacity-2);
}
</style>
